<template>
  <v-container class="fill-height d-flex justify-center">
    <v-card max-width="800" class="" width="100%">
<v-card-text>
<div v-if="!isSubmitted">
	<v-form ref="formRef" v-model="valid">
        <div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
				不具合の種類を選んでください  <span class="text-red">*</span>
			</label>
			<v-select
				v-model="form.category"
				:items="categorys"
				:rules="[required]"
				placeholder="選択してください"
				outlined
			>

		</v-select>
		</div>

		<div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
				不具合の内容をご記入ください  <span class="text-red">*</span>
			</label>
          <v-textarea
            v-model="form.detail"
            placeholder="「ゲームがフリーズする」「アイテムの名前と絵が合っていない」 等"
            :rules="[required]"
            outlined
          />
		</div>
        <div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
				不具合が発生した場所をご記入ください  <span class="text-red">*</span>
			</label>
			<v-text-field
			v-model="form.location"
			placeholder="「マーシャの酒場」「クレイディアの洞窟」 等"
			:rules="[required]"
			outlined
			/>
		</div>

        <div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
				不具合が発生した手順をご記入ください
			</label>
				<v-textarea
				v-model="form.process"
				placeholder="「オプションで移動アニメをなしに設定→○○のダンジョンでX:◆◆ Y:●●の扉を出入りした」 等"
				outlined
				/>
			</div>
			
        <div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
				どのくらいの頻度で発生していますか？
				</label>
          <v-select
            v-model="form.frequency"
            :items="frequencies"
            placeholder="選択してください"
       
            outlined
          />
		</div>
        <div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
				動画やスクリーンショットがあればリンクをお願いします
			</label>
          <v-text-field
            v-model="form.link"
            placeholder="YouTube、X(旧Twitter)URL 等"
            outlined
          />
		</div>
		<div class="mb-4">
		<label class="text-subtitle-2 font-weight-medium">
			その他、記載したほうが良いと思われる情報があればご記入ください
		</label>
          <v-textarea
            v-model="form.etc"
            placeholder="「ダウンロード版をmicroSDHCメモリーカードに保存している」 等"
            outlined
          />
		</div>
          <v-divider class="my-4" />
		<div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
			お名前 <span class="text-error">*</span>
			</label>
				<v-text-field
				v-model="form.name"
				label="お名前"
				:rules="[required]"
				outlined
				/>
		</div>
		<div class="mb-4">
			<label class="text-subtitle-2 font-weight-medium">
			メールアドレス <span class="text-error">*</span>
			</label>
			<v-text-field
				v-model="form.email"
				label="メールアドレス"
				:rules="[required, emailRule]"
				outlined
			/>
		</div>
          <div class="text-center pa-10">
            <v-btn
              color="primary"
              class="mt-4"
              :disabled="!valid"
              @click="submitForm"
            >
              送信する
            </v-btn>
          </div>
        </v-form>
        </div>
    <!-- 完了画面 -->
      <div v-else class="text-center pa-10">
        <v-icon size="64" color="success">mdi-check-circle</v-icon>
        <h2 class="text-h5 mt-4">送信ありがとうございました</h2>
        <p class="mt-2">不具合報告を受け付けました。</p>

        <v-btn class="mt-6" color="primary" @click="resetForm">
          もう一度送信する
        </v-btn>
      </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>


<script setup>
import { reactive,ref } from "vue"
import { nextTick } from "vue"

const valid = ref(false)
const formRef = ref(null)

const form = reactive({

//項目を増やすときはここを増やす
  category: null, //バグのカテゴリ
  detail: "", //簡単な説明
  location: "", //発生場所
  process:"", //再現手順
  frequency:null, //発生頻度
  link:"", //動画などへのリンク
  etc:"", //備考など
  name:"",  //名前
  email:"" //メール
})

const categorys = ["グラフィック", "システム", "テキスト", "サウンド","その他不具合"]
const frequencies = ["毎回", "たまに", "一回だけ", "不明"]

const required = v => !!v || "必須項目です"
const emailRule = v => /.+@.+\..+/.test(v) || "メール形式が不正です"

const isSubmitted = ref(false)//送信フラグ

const resetForm = () => {
  isSubmitted.value = false  // ← 先に戻す！！
  nextTick(() => {
    formRef.value?.reset()
  })
}//フォームのリセット

const submitForm = async () => {
  const isValid = await formRef.value.validate()
   if (!isValid.valid) return

  const formData = new FormData()

  formData.append("entry.109736420", form.category)
  formData.append("entry.844363439", form.detail)
  formData.append("entry.153975145", form.location)
  formData.append("entry.854976867", form.process)
  formData.append("entry.1283383934", form.frequency)
  formData.append("entry.441850075", form.link)
  formData.append("entry.989921908", form.etc)
  formData.append("entry.1662922160", form.name)
  formData.append("entry.51893534", form.email)
  try {
    await fetch(
      "https://docs.google.com/forms/d/e/1FAIpQLSfNMbp_qW6hg1vAHWVbhigvZz3YKFSQY404yznVU9zKsvDUfA/formResponse",
      {
        method: "POST",
        mode: "no-cors",
        body: formData
      }
    )
    isSubmitted.value = true
  } catch (e) {
    alert("送信に失敗しました")
  }
}
</script>

<style scoped>
.bug-form {
  max-width: 600px;
  margin: auto;
}

.field {
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
}

button:disabled {
  opacity: 0.5;
}
</style>